import { queryKeys } from "@lib/api/queryKeys";
import { fetchPermissionsForUserById } from "@lib/utils/fetchPermissions";

export const permissionQueryOptions = (userId, token) => ({
  queryKey: queryKeys.permissions.byUser(userId),
  queryFn: () => fetchPermissionsForUserById(userId),
  staleTime: 5 * 60 * 1000,
  gcTime: 10 * 60 * 1000,
  retry: 1,
  refetchOnWindowFocus: false,
  enabled: !!userId && !!token,
});
